module.exports = __webpack_public_path__ + "img/fangxin.aa9ab101.png";